import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/fix-actions`;


export const encryptAzureFiles = (
    source: CancelTokenSource)
    : Promise<void> => {

  return axios
      .post(`${apiUri}/encrypt-azure-files`, null, {cancelToken: source.token})
      .then(response => response.data);
}
